import s from "./LoadingFilms.module.scss";

const LoadingFilms = () => {
    return ( 
        <div className={s.main}>
            <div className={s.container}>
                <div className={s.container_valid}>
                    <div className={s.rate_loading}></div>
                    <div className={s.photo_loading}></div>
                    <div className={s.loading_about}>
                        <div className={s.label_loading}></div>
                        <div className={s.about_looooading}>
                            <div className={s.about_loading}></div>
                            <div className={s.about2_loading}></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={s.container}>
                <div className={s.container_valid}>
                    <div className={s.rate_loading}></div>
                    <div className={s.photo_loading}></div>
                    <div className={s.loading_about}>
                        <div className={s.label_loading}></div>
                        <div className={s.about_looooading}>
                            <div className={s.about_loading}></div>
                            <div className={s.about2_loading}></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={s.container}>
                <div className={s.container_valid}>
                    <div className={s.rate_loading}></div>
                    <div className={s.photo_loading}></div>
                    <div className={s.loading_about}>
                        <div className={s.label_loading}></div>
                        <div className={s.about_looooading}>
                            <div className={s.about_loading}></div>
                            <div className={s.about2_loading}></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={s.container}>
                <div className={s.container_valid}>
                    <div className={s.rate_loading}></div>
                    <div className={s.photo_loading}></div>
                    <div className={s.loading_about}>
                        <div className={s.label_loading}></div>
                        <div className={s.about_looooading}>
                            <div className={s.about_loading}></div>
                            <div className={s.about2_loading}></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={s.container}>
                <div className={s.container_valid}>
                    <div className={s.rate_loading}></div>
                    <div className={s.photo_loading}></div>
                    <div className={s.loading_about}>
                        <div className={s.label_loading}></div>
                        <div className={s.about_looooading}>
                            <div className={s.about_loading}></div>
                            <div className={s.about2_loading}></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={s.container}>
                <div className={s.container_valid}>
                    <div className={s.rate_loading}></div>
                    <div className={s.photo_loading}></div>
                    <div className={s.loading_about}>
                        <div className={s.label_loading}></div>
                        <div className={s.about_looooading}>
                            <div className={s.about_loading}></div>
                            <div className={s.about2_loading}></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={s.container}>
                <div className={s.container_valid}>
                    <div className={s.rate_loading}></div>
                    <div className={s.photo_loading}></div>
                    <div className={s.loading_about}>
                        <div className={s.label_loading}></div>
                        <div className={s.about_looooading}>
                            <div className={s.about_loading}></div>
                            <div className={s.about2_loading}></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={s.container}>
                <div className={s.container_valid}>
                    <div className={s.rate_loading}></div>
                    <div className={s.photo_loading}></div>
                    <div className={s.loading_about}>
                        <div className={s.label_loading}></div>
                        <div className={s.about_looooading}>
                            <div className={s.about_loading}></div>
                            <div className={s.about2_loading}></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
     );
}
 
export default LoadingFilms;